import React from 'react';
import { Skeleton } from '@sato/components';
import { twMerge } from 'tailwind-merge';

import { isLocalOrTestEnv } from '@utils/featureFlags';

import { StaticContentfulEntry } from '../contentful.constants';
import { useContentfulEntry } from '../hooks/useContentful';
import { EntryType } from '../types';

import { ResolveEntry } from './ResolveEntry';

/** Utility component for rendering a Contentful entry by given entry ID */
export const ContentfulEntry = <T extends EntryType>({
  entryId,
  className,
}: {
  entryId: StaticContentfulEntry;
  className?: string;
}) => {
  const { data: entry, isLoading } = useContentfulEntry<T>(entryId);

  if (isLoading) {
    return <Skeleton className={twMerge('h-[20rem] w-full', className)} />;
  } else if (!entry) {
    if (isLocalOrTestEnv) {
      return (
        <div>
          Invalid entry ID, doesn&apos;t match any Contentful entry:{' '}
          <strong>{entryId}</strong>
        </div>
      );
    }

    return null;
  }

  return <ResolveEntry<T> entry={entry} className={className} />;
};
